import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { FLAGS } from '~/constants/flags'
import { POS_STORE_TYPES } from '~/constants/store'

interface PantryUIStore {
  isPantry?: boolean
  enableRevampUIForPantryStore?: boolean
  storeType?: string
}

// Single source of truth for "render the Pantry UI" (PantryAdminLayout +
// route `pantryComponent`):
// - Pantry stores: per-store toggle `enableRevampUIForPantryStore`
//   (Settings > Company "Switch UI").
// - Regular (non-pantry) POS stores: experiment behind `bs-pos-p3-new-ui`.
export const usePantryUI = (store?: PantryUIStore | null) => {
  const isPosNewUIFlagOn = useFeatureIsOn(FLAGS.BS_POS_P3_NEW_UI)

  const isPantryStoreUI = Boolean(
    store?.isPantry && store?.enableRevampUIForPantryStore,
  )
  const isPosNewUI = Boolean(
    isPosNewUIFlagOn &&
      store &&
      !store.isPantry &&
      POS_STORE_TYPES.includes(store.storeType as string),
  )

  return {
    isPantryUI: isPantryStoreUI || isPosNewUI,
    isPantryStoreUI,
    isPosNewUI,
  }
}
